import UpdateConditionals from './UpdateConditionals';
import UpdateProgressBar from './UpdateProgressBar';
import ToggleNewData from './ToggleNewData';

// Remove multi-select options
export default function() {

  $('.remove-multi-select').on('click', function() {
    let el = $(this);
    let fg = el.closest('.form-group');
    let ig = fg.find('.input-group');
    let hasDependencies = ig.attr('data-has-dependencies');
    let removeVal = el.attr('data-text');
    let hidden = fg.find('.answer-text');
    let currentVal = hidden.val();
    let row = el.closest('.question-row');
    if (hidden.val() !== null && hidden.val() !== undefined) {
      row.find('.new-data').attr('value', true);
      if (currentVal.indexOf(removeVal) !== -1) {
        let newVal = '';
        let arr = currentVal.split("|");
        let i = 0;
        while (i < arr.length) {
          let potentialVal = arr[i];
          if (potentialVal !== removeVal) {
            if (newVal === '') {
              newVal = potentialVal;
            } else {
              newVal += '|' + potentialVal;
            }
          }
          i++;
        }
        hidden.val(newVal).trigger('change');
      }
    }
    el.closest('.selected-opt').remove();
    $('.tooltip').tooltip('hide');

    // Toggle new data indicator
    ToggleNewData(hidden);

    // Update conditions
    let valsChanged = $('.survey-card-body[data-val-changed=true]');
    let answer = hidden.val();
    if ((valsChanged.length > 0) && (hasDependencies === "true")) {
      UpdateConditionals(ig, answer);
    }
    UpdateProgressBar(hidden[0]);

  })

}
